import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M23 17.609a.807.807 0 0 1-1.222.695l-2.705-1.622v.959A2.373 2.373 0 0 1 16.707 20H5.98a2.37 2.37 0 0 1-2.366-2.36v-4.527A4.23 4.23 0 0 1 1 9.218 4.227 4.227 0 0 1 5.227 5h.426l-.021.02a4.25 4.25 0 0 1 3.503 2.59h7.572c1.3 0 2.366 1.067 2.366 2.363v.96l2.705-1.62a.806.806 0 0 1 1.222.689zM5.226 6.612A2.6 2.6 0 0 0 2.613 9.22c0 1.207.81 2.213 1.92 2.513a1 1 0 0 1 .144.034q.268.057.55.058a2.6 2.6 0 0 0 2.558-3.15 1 1 0 0 1-.034-.142 2.604 2.604 0 0 0-2.525-1.92m11.481 2.612H9.456c-.003 2.32-1.904 4.211-4.228 4.211v4.206c0 .424.323.746.752.746h10.727c.43 0 .752-.322.752-.746v-2.334a1 1 0 0 1 0-.09V9.975a.736.736 0 0 0-.752-.75m4.679 6.963v-4.763l-2.313 1.386v1.99z",
      class: "hidden qmusic:block"
    }, null, -1),
    _createElementVNode("path", {
      d: "M18.53 15.242v1.113A2.654 2.654 0 0 1 15.87 19H3.66A2.654 2.654 0 0 1 1 16.355v-8.71A2.654 2.654 0 0 1 3.661 5H15.87a2.654 2.654 0 0 1 2.661 2.645V8.73l3.08-1.835a.92.92 0 0 1 .921-.015c.29.161.469.466.469.795v8.617a.91.91 0 0 1-.463.796.92.92 0 0 1-.928-.01zm0-4.386v2.255l2.633 1.57V9.286zm-1.8-3.166c0-.502-.412-.91-.916-.91H3.72a.913.913 0 0 0-.915.91v8.627c0 .501.41.91.915.91h12.094a.913.913 0 0 0 .915-.91z",
      class: "hidden joe-be:block joe:block"
    }, null, -1)
  ])))
}
export default { render: render }